import React from 'react'

import type { AnimatedLineProps } from '@mui/x-charts'

interface CustomLineProps extends AnimatedLineProps {
  lineColor?: string
}

export const CustomLine: React.FC<CustomLineProps> = (props) => {
  return (
    <>
      <clipPath id={props.id}>
        <rect height={props.height} width={props.width} x="0" y="0" />
      </clipPath>
      <g>
        <path
          cursor="unset"
          d={props.d}
          style={{
            strokeWidth: 2,
            strokeLinejoin: 'round',
            fill: 'none',
            stroke: props.lineColor ? props.lineColor : props.stroke,
            transition: 'opacity 0.2s ease-in, stroke 0.2s ease-in',
            opacity: 1,
          }}
        />
      </g>
    </>
  )
}
